if (!customElements.get('variant-color-groups')) {
  customElements.define(
    'variant-color-groups',
    class VariantColorGroups extends HTMLElement {
      constructor() {
        /*************************************************
        Product - Color Selector
        *************************************************/
        var colorLabels = document.querySelectorAll(".variant-color__button-label");
        var colorRadios = document.querySelectorAll("[data-variant-input-color]");
        window.selectedColor;

        colorLabels.forEach(function(label, idx) {
          if (idx == 0) {
            window.selectedColor = label.textContent.toLowerCase();
            colorRadios[idx].setAttribute('checked', 'checked');
          }

          label.addEventListener("click", function(e) {

            colorRadios.forEach(function(radio) {
              radio.removeAttribute('checked');
            });

            colorRadios[idx].setAttribute("checked", "checked");
            window.selectedColor = label.textContent.toLowerCase();
          });
        });

        /*************************************************
        Product - Stock Status Message
        *************************************************/
        var swatches = document.querySelectorAll(".color-swatch");
        var stockMessage = document.querySelector(".stock-status-p");
        var brandSel = document.querySelectorAll(".product-single__vendor a");

        var brand = "";
        if ( brandSel.length ) {
          var brand = brandSel[0].textContent;
        }

        /*
        swatches.forEach(function(swatch){
          swatch.addEventListener('click', function(e){
            if(e.target.classList.contains('disabled')){
              stockMessage.innerHTML = '<span class="stock-status-text">Stock Status:</span> This option is currently unavailable.';
            } else if (brand.indexOf('Estetica') > -1) {
              stockMessage.innerHTML =
                '<span class="stock-status-text">Stock Status:</span> Orders process in 3 - 10 days';
            } else {
              stockMessage.innerHTML =
                '<span class="stock-status-text">Stock Status:</span> Available and ready to ship!';
            }
          });
        });
        */
        /*************************************************
        Product - Tabbed Content
        *************************************************/
        var tabs = document.querySelectorAll("[data-tabbed-content-target]");
        var tabItems = document.querySelectorAll('.tabbed-content__item');

        tabs.forEach(function(tab){
          tab.addEventListener('click', function(){
            var target = document.querySelector(tab.dataset.tabbedContentTarget);

            tabItems.forEach(function(tabItem) {
              tabItem.classList.remove('active');
            });

            tabs.forEach(function (tab) {
              tab.classList.remove("active");
            });

            target.classList.add('active');
            tab.classList.add('active');
            target.style.height = 'auto';
          });
        });

        /*************************************************
        Product - Variant Filter
        *************************************************/
        var colorFamilyBtns = document.querySelectorAll(".variant-input-color");
        var colorSwatches = document.querySelectorAll(".product-form__input--color .swatch-image");
        colorFamilyBtns.forEach(function (colorFamBtn) {
          colorFamBtn.addEventListener("click", function (e) {
            colorSwatches.forEach(function (color) {
              color.style.display = "none";
            });
            let saleItem = 0;
            const hiddenMsg = document.querySelector('span[data-no-sale]');
            colorSwatches.forEach(function (color) {
              if (color.dataset.colorFamily != colorFamBtn.id) {       
                color.style.display = 'none';
              } else {     
                color.style.display = 'inline-flex';               
                        
                if(color.classList.contains('sale-group-true')) {          
                  saleItem = saleItem + 1;                   
                }
              
                if(saleItem == 0) {
                  hiddenMsg?.classList.remove('hidden');
                } else {
                  hiddenMsg?.classList.add('hidden'); 
                }
              }
            });

            if (e.target.parentNode.id == 'all') {
              colorSwatches.forEach(function (color) {
                color.style.display = "inline-flex";

                if(color.classList.contains('sale-group-true')) {          
                  saleItem = saleItem + 1;                   
                }
                if(saleItem == 0) {
                  hiddenMsg?.classList.remove('hidden');
                } else {
                  hiddenMsg?.classList.add('hidden'); 
                }
              });
            }
          });
        })

        // Add Custom Class to modal
        var customQuickCartBtns = document.querySelectorAll(".custom_quick_add");
        customQuickCartBtns.forEach(function(btn){
          btn.addEventListener('click', function(e){
            document.body.classList.add("active_quick_add");
          });
        });

        // Add Custom Class  modal
        var modalCloseSel = document.querySelectorAll(".js-modal-close");
        modalCloseSel.forEach(function(btn){
          btn.addEventListener('click', function(e){
            document.body.classList.remove("active_quick_add");
          });
        });

        (() => {
          document.querySelectorAll('.slideshow-wrapper .hero.loading').forEach(el=>{
            el.classList.add('bg_loading');
          })

          var colorSwatcheFamily = document.querySelectorAll(".swatch-image[data-color-family]");

          // Show Color family for available variants
          document.querySelectorAll('.swatch-image[data-color-family]').forEach(el => {
            let colorFamily = el.getAttribute('data-color-family');   
            document.querySelector(`#${colorFamily}`).style.display = 'inline-flex';
          });


          // Hide "All" if no variants available
          if ( colorSwatcheFamily.length == 0 && document.querySelector('#all.swatch-image-color')) {
            document.querySelector('#all.swatch-image-color').style.display = 'none';
          }


          /*************************************************
          Collection - Variant Filter for modal
          *************************************************/
          document.addEventListener('click', ev => {
            document.querySelectorAll('.modal__inner .variant-color__button-label').forEach(el => {
              if(el == ev.path[0]) { //ev.path[0] looks to match the jQuery.on functionality of dymanic elements. We're just looking to see if we can find that .modal__inner .variant-color__button-label
                let dataFor = el.getAttribute('for');
                let thisModal = el.closest('.variant-wrapper');

                // Trigger Input
                thisModal.querySelectorAll('.swatch-image-color input').forEach(vC => {vC.checked = false;});
                thisModal.querySelector(`.swatch-image-color input[name="${dataFor}"]`).checked = true;

                // Trigger Color
                thisModal.querySelectorAll('.swatch-image').forEach(vI=>{vI.style.display = 'none';});

                let colorVal = dataFor.replace('color-', '');
                if(colorVal == 'all') {
                  thisModal.querySelectorAll('.swatch-image').forEach(vI=>{vI.style.display = 'inline-flex';});
                } else {
                  thisModal.querySelectorAll(`.swatch-image[data-color-family="${colorVal}"]`).forEach(vI => {vI.style.display = 'inline-flex';});
                }
              }
            });
          });

          /*************************************************
          Collection - Variant Default Selection
          *************************************************/
          document.addEventListener('product-quickview-loaded', () => {
            document.querySelector('.modal--is-active #all-modal input[type="radio"]').checked = true;
          });

          /*************************************************
          Review Click Open Review form
          *************************************************/
          //
          try {
            document.addEventListener('click', ev => {
              ev.path?.forEach(e => {
                if(e == document.querySelector('#custom_review_button')) {
                  document.querySelector('[data-tabbed-content-target="#review"]').click()
                }
              });
            });
          } catch (error) {
            console.log(error)
          }

          //Change text Be the fisrt to review
          var box = document.querySelectorAll('#custom_review_button');
          setTimeout(() => {
            box.forEach((item) => {
              var messageReview = item.querySelector('.spr-badge-caption');
              if (messageReview && messageReview.innerHTML == 'Be the first to review this product') {
                messageReview.textContent = 'Be the first to review';
              }
              item.style.display = 'block';
            });
          }, 3000);
          // Review for mobile
          // jQuery('#custom_review').on('click', function(){
          //   let content = jQuery('.custom_review_form_desktop').html();
          //   jQuery('.custom_review_mobile').html(content);
          // });

          const isVisible = (el) => {
            element = document.querySelector(el) || {innerHeight: 0, innerWidth: 0};
            return element.innerWidth * element.innerHeight;
          }

          if(isVisible('.custom_review_form_mobile')){
            document.querySelector('#shopify-product-reviews').insertAfter('.custom_review_form_mobile');
          }
          if(isVisible('.custom_review_form_desktop')){
            document.querySelector('#shopify-product-reviews').insertAfter('.custom_review_form_desktop');
          }

          // Tags Single category active link
          let currentTag = window.location.pathname;
          jQuery('.blog_tags_list a').each(function(i, el){
              let thisUrl =  jQuery(el).attr('href');
              let result  = thisUrl.match(currentTag);
              if( result ) {
                  jQuery(el).addClass('active');
                  return false;
              }
          });

          /************************************************
          Product - More Information Expanded
          ************************************************/
          if (location.href.indexOf('/products') > -1) {
            var accordions = document.querySelectorAll(
              "#details .tabbed-content__section-half .collapsibles-wrapper"
            );

            // console.log(accordions);

            if (accordions.length > 1) {
              return;
            } else {
              // console.log("ACCORDION: " + JSON.stringify(accordions[0]));
              if (accordions[0] && accordions[0].querySelector('button').textContent.indexOf('MORE INFO') > -1) {
                accordions[0].querySelector('button').click();
              }
            }
          }
        })();
      }
    }
  );
}